import { defineComponent as E, ref as i, computed as r, watchEffect as S, openBlock as f, createBlock as _, Transition as l, withCtx as c, withDirectives as p, createElementVNode as h, createVNode as t, unref as u, createCommentVNode as $, vShow as m } from "vue";
import { DeviceKind as N } from "@thehotelsnetwork/personalization-types";
import { u as V, b, c as z, m as v, f as O, e as T, t as A } from "./popup.es.js";
import "tinycolor2";
import "@vueuse/core";
import "@thehotelsnetwork/icons/vue/linear";
const B = ["data-position", "data-size"], I = /* @__PURE__ */ E({
  __name: "Sticky",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(x, { expose: g }) {
    const e = x, o = V(), s = i(!1), d = i(!1), n = i(), y = r(() => {
      if (n.value)
        return n.value.offsetHeight * 0.6;
    });
    r(() => !!e.layout.closeOnClickOutside);
    const k = r(() => {
      const { position: a } = e.layout;
      return a ? `fade-from-${a.slice(-1) === "L" ? "left" : "right"}` : "fade";
    });
    S(() => {
      o == null || o.styles.addCssVariables(
        o.literals.device === N.Desktop ? {
          "--step-padding": "24px",
          "--module-margin-top": "10px",
          "--xclose-margin": "5px"
        } : {
          "--step-padding": "24px",
          "--module-margin-top": "8px",
          "--xclose-margin": "5px"
        }
      );
    });
    function w() {
      s.value = !1;
    }
    function C() {
      s.value = !0;
    }
    function D() {
      d.value = !0;
    }
    return g({
      show: w,
      hide: C
    }), (a, H) => (f(), _(l, {
      name: "fade",
      appear: "",
      onAfterEnter: D
    }, {
      default: c(() => [
        p(h("div", {
          class: "thn--tool-sticky",
          ref_key: "rootDom",
          ref: n
        }, [
          t(l, { name: k.value }, {
            default: c(() => [
              p(h("div", {
                class: "thn--tool-sticky__popup",
                "data-position": a.layout.position,
                "data-size": e.layout.size
              }, [
                t(b, { class: "thn--tool-sticky__back" }),
                t(z, {
                  class: "thn--tool-sticky__steps",
                  steps: e.steps,
                  "has-extra-steps": e.hasSteps,
                  "max-height": y.value
                }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                u(v) ? $("", !0) : (f(), _(O, { key: 0 })),
                t(l, { name: "fade" }, {
                  default: c(() => [
                    p(t(T, { "terms-text": u(A) }, null, 8, ["terms-text"]), [
                      [m, u(v)]
                    ])
                  ]),
                  _: 1
                })
              ], 8, B), [
                [m, !s.value && d.value]
              ])
            ]),
            _: 1
          }, 8, ["name"])
        ], 512), [
          [m, !s.value]
        ])
      ]),
      _: 1
    }));
  }
});
export {
  I as default
};
//# sourceMappingURL=popup-p-components-Sticky.js.map
